import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import memberDealsSrc from './images/member-deals-thumb.avif';

const memberDeals = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Member Deals' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Exclusive savings on apparel, outdoor accommodations, flights, and more' }),
  thumbnailImage: memberDealsSrc.src
});

export default memberDeals;
